import consumer from './consumer';
import { log } from '../utils/logger';

consumer.subscriptions.create('Notifications::OrganizationChannel', {
  connected() {
    log('connected to Notifications::OrganizationChannel');
  },

  disconnected() {
    log('disconnected from Notifications::OrganizationChannel');
  },

  received(data) {
    log('message received from Notifications::OrganizationChannel', data);

    const notificationsContainer = document.getElementById(
      'notification-container'
    );
    notificationsContainer.innerHTML = data.html;
  },
});
